import { Tag, BackTop, Button, Row, Col } from 'antd';
import React, { useEffect, useRef, useState } from 'react';
import { useLocation, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { Carousel } from 'react-responsive-carousel';
import { BsFillArrowUpCircleFill } from 'react-icons/bs';
import { Header2 } from './header';
import { MdLocationPin } from 'react-icons/md';
import { useNavigate } from 'react-router-dom';
import { LinkOutlined } from '@ant-design/icons';

import { Loader } from '../../components/loader';
import useFetch from '../../_fetch';

import './styles.less';
import { HotelInfo } from './HotelInfo';
import useBreakpoint from 'antd/lib/grid/hooks/useBreakpoint';

export default function HotelHome() {

	const [loading, setLoading] = useState(true);
	const [data, setData] = useState({});
	const [geoCodes, setGeoCodes] = useState({});
	const [heroImages, setHeroImages] = useState([]);
	const [logo, setLogo] = useState('https://dhv90r5m1wdoe.cloudfront.net/default-logo.png');
	const breakpoints = useBreakpoint();

	const { hotel } = useParams();

	let navigate = useNavigate();
	const search = useLocation().search;
	const id = new URLSearchParams(search).get("id");

	const photoRef = useRef(null);
	const amenitiesRef = useRef(null);
	const reviewRef = useRef(null);
	const locationRef = useRef(null);
	const overviewRef = useRef(null);
	const offersRef = useRef(null);

	function getImage(image) {
		if (image.sizes) {
			if (image.sizes["2160"]) return image.sizes["2160"].href
			else if (image.sizes["1080"]) return image.sizes["1080"].href
			else if (image.sizes["800"]) return image.sizes["800"].href
			else if (image.sizes["320"]) return image.sizes["320"].href
			else return 'https://dhv90r5m1wdoe.cloudfront.net/default_bg.png';
		}
		else return 'https://dhv90r5m1wdoe.cloudfront.net/default_bg.png';
	}

	const _fetch = useFetch();

	useEffect(() => {

		async function init() {
			try {
				setLoading(true);
				let _id = id;

				if (!_id && hotel) {
					let arr = hotel.split('-');
					_id = arr[arr.length - 1];
				} else if (!_id && !hotel) {
					navigate('/');
				}

				let res = await _fetch(process.env.REACT_APP_API_URL + `/hotel?_id=${_id}`);
				res = await res.json();
				if (res.success) {
					if (res.response.hotel?.length === 0) {
						toast.error('hotel not found');
						return navigate('/');
					}
					setData(res.response.hotel[0]);
					setGeoCodes(res.response.hotel[0].geoCodes);
					setHeroImages(res.response.hotel[0].images.filter(e => e.heroImage));
					let logo = res.response.hotel[0].images.find(e => e.category === 'LG');

					console.log(logo)

					if (logo) {
						setLogo(getImage(logo))
					}
					let facts = res.response.hotel[0].facts;
					let arr = [];

					for (let fact in facts) {
						arr.push({ fact, factValue: facts[fact] });
					}

				}
			} catch (e) {
				console.log(e);
				toast.error('Some error occurred please try again later');

			} finally {
				setLoading(false);
			}
		}

		init();

		// eslint-disable-next-line react-hooks/exhaustive-deps
	}, []);

	if (loading) {
		return (<Loader />)
	}

	return (
		<React.Fragment>

			<link
				rel="stylesheet"
				type="text/css"
				charset="UTF-8"
				href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick.min.css"
			/>
			<link
				rel="stylesheet"
				type="text/css"
				href="https://cdnjs.cloudflare.com/ajax/libs/slick-carousel/1.6.0/slick-theme.min.css"
			/>
			<Header2
				photoRef={photoRef} amenitiesRef={amenitiesRef} locationRef={locationRef} reviewRef={reviewRef} overviewRef={overviewRef} offersRef={offersRef}
				urls={data.urls}
			/>

			<section id='hotel_page'
				style={{
					paddingTop: breakpoints.md ? 90 : 130,
					background: 'linear-gradient(180deg, #E7EFF5 0%, rgba(231, 239, 245, 0) 100%)',
					position: 'sticky',
				}}
			>
				<div className='container'>
					<div className={`d-flex ${breakpoints.md ? 'flex-row justify-content-between align-items-center' : 'flex-row'}`}>
						<div>
							<h2 className='d-flex align-items-center fw-bold'>
								<span>
									{data.names}
									{data.status === 'UNPUBLISHED' && <Tag color='#f50' className='my-auto ms-3 rounded'>Unpublished</Tag>}
								</span>
							</h2>
							<div
								className='d-flex flex-row align-items-center pointer mb-4'
								onClick={() => locationRef.current?.scrollIntoView()}
							>
								<MdLocationPin className='fs-4 me-2' />
								<p className='mb-0 pointer fs-6 text-primary' >
									{data.addresses?.addressLines?.join(', ')}
								</p>
							</div>
						</div>
					</div>

					<div className="mb-4">
						<Row
							gutter={[16, 16]}
							style={{
								height: breakpoints.lg ? 450 : 250,
							}}
						>
							<Col
								xs={24}
								lg={14}
								style={{
									height: '100%',
								}}
							>
								<Carousel
									showThumbs={false} showIndicators={false} showStatus={false}
									autoPlay={true} infiniteLoop={true} interval={5000} showArrows={false}
									transitionTime={1000} swipeable={false} animationHandler='fade'
									className='carousel-root-container overflow-hidden'
								>
									{
										heroImages.length ?
											heroImages.map((e, i) => (
												<div
													key={`h-${i}`}
													style={{
														width: '100%',
														margin: '0 auto',
														height: breakpoints.lg ? 450 : 250,
														borderRadius: '10px',
														overflow: 'hidden',
													}}
												>
													<img src={getImage(e)} style={{ objectFit: 'cover', height: '100%', width: '100%' }} className='hero-image' alt='...' />
												</div>
											))
											:
											<div style={{
												width: '100%',
												margin: '0 auto',
												height: breakpoints.lg ? 450 : 250,
												backgroundSize: "cover",
												backgroundImage: `url('https://dhv90r5m1wdoe.cloudfront.net/default_bg.png')`,
												backgroundPositionX: 'center',
												backgroundPositionY: 'center',
												borderRadius: '10px',
												overflow: 'hidden',
											}} className='hero-image' />
									}
								</Carousel>
							</Col>
							<Col
								xs={0}
								lg={4}
								style={{
									height: '100%',
								}}
							>
								<div
									className='w-100 h-100 d-flex flex-row flex-md-column justify-content-between align-items-center'
								>
									{
										data.images?.filter(e => e.heroImage === false)?.slice(0, 3).map((e, i) => (
											<div
												className='small-image-container'
											>

												<img
													key={`h-${i}`}
													src={getImage(e)}
													alt={data.names}
													className='img-fluid'
													style={{
														width: '100%',
														height: '100%',
														objectFit: 'cover',
														borderRadius: '10px',
														overflow: 'hidden',
													}}
												/>
												{
													i === 2 && data.images?.filter(e => e.heroImage === false)?.length > 3 && (
														<div
															className='d-flex flex-row justify-content-center align-items-center py-2 px-3 rounded image-count-container'
															style={{
																position: 'absolute',
																bottom: '10%',
																right: '10%',
																backgroundColor: '#fff',
																cursor: 'pointer',
															}}
															onClick={() => {
																photoRef?.current?.scrollIntoView();
															}}
														>
															<h4
																className='text-center fs-6 m-0'
															>
																+{data.images?.filter(e => e.heroImage === false)?.length - 3} more
															</h4>

														</div>
													)
												}
											</div>

										))
									}

								</div>
							</Col>
							<Col
								xs={0}
								lg={6}
								style={{
									height: '100%',
								}}
							>
								<div
									className='contact-us-card p-3'
								>
									<div
										className=' w-100 rounded p-2 logo-container overflow-hidden d-flex align-items-center justify-content-center'
									>
										<img className='h-100 object-fit-contain' src={logo} alt={data.names} />

									</div>
									<h2
										className='text-center fw-bold fs-4'
									>
										Contact Info
									</h2>
									<div
										className='d-flex flex-row justify-content-center align-items-center'
									>
										{
											data.phones?.filter(e => e.tech === 'phone')?.slice(0, 2).map((e, i) => (
												<h4
													className='text-center fw-bold fs-5 mx-2'
												>
													{e.phone}
												</h4>
											))
										}
									</div>
									<div className="dashed-hr" />
									{
										data.emails && data.emails.length > 0 && (
											<h4
												className='text-center fw-bold fs-6 text-wrap mx-2 text-break'
											>
												{data.emails[0].email}
											</h4>
										)
									}
									<Button
										disabled={!data?.direct_link}
										htmlType='button'
										size='large'
										type='primary'
										className='rounded w-100'
										onClick={() => {
											window.open(data?.direct_link, '_blank')
										}}
									>
										Book Now
									</Button>
									<Button
										className='w-100 rounded'
										onClick={() => window.open(Array.isArray(data.urls) && data.urls.length ? data.urls[0].url : '#', '_blank')}
										type='primary'
										size='large'
										icon={<LinkOutlined className='me-2' />}
										style={{
											backgroundColor: '#000',
											color: '#fff',
											border: 'none',
										}}
									>
										Visit Website
									</Button>
								</div>

							</Col>

						</Row>
						<Button
							disabled={!data?.direct_link}
							htmlType='button'
							size='large' type='primary'
							className='rounded w-100 d-md-none my-2 mt-4'
							onClick={() => {
								window.open(data?.direct_link, '_blank')
							}}
						>
							<span
								style={{
									fontSize: '18px'
								}}
							>
								Book Now
							</span>
						</Button>
					</div>
				</div>
			</section >

			<section id='hotel-detail' className='pt-md-0 mb-5 pb-3'>
				<div className='container'>
					<HotelInfo
						data={data} geoCodes={geoCodes} overviewRef={overviewRef}
						photoRef={photoRef} amenitiesRef={amenitiesRef}
						locationRef={locationRef} reviewRef={reviewRef}
						offersRef={offersRef}
					/>
				</div>

			</section>

			<BackTop>
				<BsFillArrowUpCircleFill className='text-primary' size={40} />
			</BackTop>

		</React.Fragment >
	)
}
